<template>
  <div :class="`route-${$route.name}`">
    <AppHeader @toggleMenu="showSidebar = !showSidebar" />

    <MtxBreadcrumb class="pt-2 px-2" />

    <div class="px-2">
      <RouterView />
    </div>

    <MtxDrawer v-model="showSidebar" bgTransition="fade" transition="fade-right">
      <AppSidenav />
    </MtxDrawer>

    <StarryNight />
    <TxModal />
    <Web3Modal />
    <PendingTxs />
    <TermsBanner />

    <notifications position="bottom center" />
    <EthNotifications />
    <IPFSCheck />
  </div>
</template>

<script>
import AppHeader from "@/components/misc/AppHeader"
import AppSidenav from "@/components/misc/AppSidenav"
import IPFSCheck from "@/components/misc/IPFSCheck"
import PendingTxs from "@/components/misc/PendingTxs"
import TermsBanner from "@/components/misc/TermsBanner"
import TxModal from "@/components/misc/TxModal"
import Web3Modal from "@/components/misc/Web3Modal"
import StarryNight from "@/components/misc/StarryNight"
import EthNotifications from "@/components/misc/EthNotifications"

export default {
  components: {
    AppHeader,
    AppSidenav,
    IPFSCheck,
    PendingTxs,
    TermsBanner,
    TxModal,
    Web3Modal,
    StarryNight,
    EthNotifications
  },

  data: () => ({
    showSidebar: false
  }),

  metaInfo: {
    title: "Matryx"
  },

  watch: {
    "$route.fullPath": function() {
      this.showSidebar = false
    }
  }
}
</script>
